var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "sb-base-table sb-base-table2",
        _vm.fullHeightTable ? "sb_full_height_table" : ""
      ]
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    [
                      _c("v-flex", [
                        _vm._v(" " + _vm._s(_vm.alertMessage) + " ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "c-pointer",
                              on: {
                                click: function($event) {
                                  _vm.dialog = false
                                }
                              }
                            },
                            [_vm._v(" close ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("above-table", null, {
        items: _vm.items,
        totalItems: _vm.totalItems,
        selectedItems: _vm.selectedItems,
        currentPage: _vm.currentPage,
        extraResponseProperties: _vm.extraResponseProperties,
        displayedColumns: _vm.displayedColumns,
        allColumns: _vm.allColumns,
        filteredItems: _vm.filteredItems
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _vm._t("top-actions", null, {
                items: _vm.items,
                selectedItems: _vm.selectedItems,
                currentPage: _vm.currentPage,
                extraResponseProperties: _vm.extraResponseProperties
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.columnFilterable || _vm.downloadable
            ? _c(
                "div",
                { staticClass: "UDM_GS_HeaderIcons d-flex align-center" },
                [
                  _vm.columnFilterable
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            id: _vm.tableId + "-btn-filter_list",
                            icon: "",
                            flat: "",
                            depressed: "",
                            fab: "",
                            disabled: _vm.disableFiltersButton
                          },
                          on: { click: _vm.headerColumntoggle }
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attr = ref.attr
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "material-icons-round filter-list"
                                              },
                                              "v-icon",
                                              attr,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("filter_list")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3360441040
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  " Choose which table columns to display "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.downloadable
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attr = ref.attr
                                  return [
                                    _c(
                                      "button",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "mr-0 sb_mc_export_btn",
                                            attrs: {
                                              id: _vm.tableId + "-btn-download",
                                              disabled:
                                                _vm.disableDownloadButton
                                            },
                                            on: { click: _vm.exportFullTable }
                                          },
                                          "button",
                                          attr,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "base-card-download-svg",
                                            attrs: {
                                              width: "13",
                                              height: "13",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d:
                                                  "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("polyline", {
                                              attrs: {
                                                points: "7 10 12 15 17 10"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("line", {
                                              attrs: {
                                                x1: "12",
                                                y1: "15",
                                                x2: "12",
                                                y2: "3"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Export")])
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            786247517
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(" Download this table as a CSV file ")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showColumnsHeader && !_vm.hideColumnToggleBtn
        ? _c(
            "v-row",
            { staticClass: "sb_expand_column_header d-flex" },
            [
              _c(
                "v-col",
                { staticClass: "text-center col-12" },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attr = ref.attr
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          depressed: "",
                                          fab: "",
                                          small: ""
                                        }
                                      },
                                      "v-btn",
                                      attr,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.expandColumnHeader === false,
                                            expression:
                                              "expandColumnHeader === false"
                                          }
                                        ],
                                        attrs: { medium: "" },
                                        on: { click: _vm.headerColumntoggle }
                                      },
                                      [
                                        _vm._v(
                                          "\n              arrow_drop_down\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-icon",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.expandColumnHeader === true,
                                            expression:
                                              "expandColumnHeader === true"
                                          }
                                        ],
                                        attrs: { small: "" },
                                        on: { click: _vm.headerColumntoggle }
                                      },
                                      [
                                        _vm._v(
                                          "\n              close\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        98759471
                      )
                    },
                    [_vm._v(" "), _c("span", [_vm._v("Columns")])]
                  ),
                  _vm._v(" "),
                  _c("v-divider")
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.expandColumnHeader
        ? _c(
            "div",
            [
              _c(
                "v-layout",
                {
                  staticClass: "sb_columns_container",
                  attrs: { row: "", wrap: "" }
                },
                [
                  _vm._l(
                    _vm.allColumns.filter(function(c) {
                      return !c.hidden
                    }),
                    function(column, columnIndex) {
                      return _c(
                        "v-btn",
                        {
                          key: columnIndex,
                          attrs: {
                            id:
                              _vm.removeSpecialCharacters(column.source) +
                              "_Header",
                            title: column.tooltip,
                            color: column.visible ? undefined : "outline",
                            dark: column.visible,
                            selected: ""
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.columnSelection(column)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(column.rename || column.source) +
                              "\n      "
                          )
                        ]
                      )
                    }
                  ),
                  _vm._v(" "),
                  _vm.$store.getters.userIsAdmin
                    ? _c("div", { staticClass: "pt-1" }, [
                        _c(
                          "a",
                          {
                            staticClass: "caption pa-2",
                            attrs: {
                              href:
                                _vm.SbBaseUrl +
                                "/Admin/#/table-controls/" +
                                _vm.tableKey,
                              target: "_blank"
                            }
                          },
                          [_vm._v("\n          Configure this table\n        ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: ["sb-mc-table__wrapper", _vm.tableId] }, [
        _c(
          "table",
          {
            staticClass: "sb-mc-table v-datatable v-table",
            attrs: { id: _vm.tableId }
          },
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm.selectable && !_vm.hideSingleSelectCheckbox
                    ? _c(
                        "th",
                        { staticClass: "sb_table_selectAll_checkbox" },
                        [
                          _c(
                            "filter-header",
                            {
                              attrs: {
                                "hide-filter-input": "",
                                "single-icon": ""
                              }
                            },
                            [
                              !_vm.singleSelection
                                ? _c("v-checkbox", {
                                    staticClass: "ml-2 pt-3",
                                    attrs: {
                                      "input-value":
                                        _vm.selectedIds.length ===
                                        _vm.items.length,
                                      indeterminate: _vm.selectedIds.length > 0,
                                      disabled: _vm.singleSelection,
                                      primary: "",
                                      "hide-details": ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.toggleSelectAll($event)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("header-left"),
                  _vm._v(" "),
                  _vm._l(_vm.displayedColumns, function(column, columnIndex) {
                    return _c(
                      "th",
                      {
                        key: columnIndex,
                        class: { count_column: column.type !== "text" },
                        attrs: { title: column.tooltip }
                      },
                      [
                        _c("filter-header", {
                          key: _vm.filters[column.source],
                          attrs: {
                            label: column.rename || column.source,
                            type: column.type,
                            "clear-inputs": _vm.clearInputs,
                            "filter-type": _vm.filterTypes[column.source],
                            "is-sorted":
                              _vm.sorting.sortColumn === column.source,
                            "sort-dir":
                              _vm.sorting.sortColumn === column.source
                                ? _vm.sorting.sortDirection
                                : "default",
                            value: _vm.filters[column.source],
                            "previous-header-name": _vm.previousHeader
                          },
                          on: {
                            toggleInput: _vm.toggleInput,
                            "change:header": function(e) {
                              return _vm.updatePreviousHeader(e)
                            },
                            "updated:sort": function(sortDirection) {
                              return (_vm.sorting = {
                                sortColumn: column.source,
                                sortDirection: sortDirection
                              })
                            },
                            "updated:filter": function(value) {
                              return _vm.$set(
                                _vm.filterTypes,
                                column.source,
                                value
                              )
                            }
                          },
                          model: {
                            value: _vm.filters[column.source],
                            callback: function($$v) {
                              _vm.$set(_vm.filters, column.source, $$v)
                            },
                            expression: "filters[column.source]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm.items.length === 0
                  ? _c("tr", [
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan:
                              _vm.displayedColumns.length +
                              (_vm.selectable ? 1 : 0) +
                              (_vm.extraColumn ? 1 : 0)
                          }
                        },
                        [
                          _c(
                            "v-alert",
                            {
                              staticClass: "sb_mc_table_status_alert",
                              attrs: { value: _vm.loading, type: "info" }
                            },
                            [_vm._v("\n              Loading...\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-alert",
                            {
                              staticClass: "sb_mc_table_status_alert",
                              attrs: { value: !_vm.loading, type: "info" }
                            },
                            [_vm._t("no-data", [_vm._v(" No items to show ")])],
                            2
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.items, function(item, itemIndex) {
                  return _c(
                    "tr",
                    {
                      key: itemIndex,
                      class: [
                        _vm.selectable ? "c-pointer" : "",
                        _vm.selectedIds.includes(item[_vm.selectItemKey]) &&
                        _vm.addActiveClass
                          ? "active"
                          : "",
                        _vm.selectedIds.includes(item[_vm.selectItemKey])
                          ? ""
                          : _vm.backgroundColorFunction(item)
                      ],
                      on: {
                        click: function($event) {
                          return _vm.toggleSelection(item)
                        }
                      }
                    },
                    [
                      _vm.selectable && !_vm.hideSingleSelectCheckbox
                        ? _c(
                            "td",
                            { staticClass: "sb_table_checkbox" },
                            [
                              item.selectable !== false
                                ? _c("v-checkbox", {
                                    staticClass: "mt-0 mc-table-select",
                                    attrs: {
                                      "input-value": _vm.selectedIds.includes(
                                        item[_vm.selectItemKey]
                                      ),
                                      primary: "",
                                      "hide-details": "",
                                      disabled: item.selectable === false
                                    }
                                  })
                                : _c(
                                    "v-icon",
                                    { attrs: { title: item.noSelectMessage } },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            item.noSelectIcon ||
                                              _vm.SbIcons.status.warn
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("body-left", null, {
                        item: item,
                        items: _vm.items
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.displayedColumns, function(
                        column,
                        columnIndex
                      ) {
                        return _c(
                          "td",
                          { key: columnIndex },
                          [
                            _vm._t(
                              column.source + "-body",
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getDisplayValue(
                                        item[column.source],
                                        column.type
                                      )
                                    ) +
                                    "\n            "
                                )
                              ],
                              { value: item[column.source], item: item }
                            )
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("tfoot", [
              _c("tr", [
                _c("td", {
                  attrs: {
                    colspan:
                      _vm.displayedColumns.length +
                      (_vm.selectable ? 1 : 0) +
                      (_vm.extraColumn ? 1 : 0)
                  }
                })
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "caption sb_mc_table_footer", attrs: { xs12: "" } },
            [
              _vm.selectable &&
              _vm.selectedItems.length > 0 &&
              !_vm.hideSelectedItemsCount
                ? _c("span", { staticClass: "sb_table_selected_items_count" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.selectedItems.length) +
                        " item" +
                        _vm._s(_vm.selectedItems.length > 1 ? "s" : "") +
                        "\n        selected\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.totalItems > _vm.initialPageSize
                ? [
                    _c("div", { staticClass: "sb_mc_footer_controls" }, [
                      _c(
                        "div",
                        { staticClass: "sb_mc_footer_page_size" },
                        [
                          _c("span", { staticClass: "pr-2" }, [
                            _vm._v(" Rows per page: ")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "ma-0 pt-0 page-size-select",
                            attrs: {
                              id: _vm.tableId + "_RowsPerPage",
                              items: _vm.pageSizeOptions
                            },
                            model: {
                              value: _vm.pagination.pageSize,
                              callback: function($$v) {
                                _vm.$set(_vm.pagination, "pageSize", $$v)
                              },
                              expression: "pagination.pageSize"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "sb_mc_footer_pagination" },
                        [
                          _c(
                            "span",
                            { staticClass: "sb_mc_table_page_description" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.currentPageDescription) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                id: _vm.tableId + "_PrevPage",
                                flat: "",
                                disabled: _vm.pagination.page === 0
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.pagination.page -= 1
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("chevron_left")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                id: _vm.tableId + "_NextPage",
                                flat: "",
                                disabled:
                                  (_vm.pagination.page + 1) *
                                    _vm.pagination.pageSize >=
                                  _vm.filteredItems
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.pagination.page += 1
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("chevron_right")])],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("below-table", null, {
        items: _vm.items,
        selectedItems: _vm.selectedItems,
        currentPage: _vm.currentPage,
        extraResponseProperties: _vm.extraResponseProperties
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }